function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable react/no-multi-comp */
/* eslint-disable comma-spacing */
/* eslint-disable max-lines */
import React, { Component } from 'react';
import { DropTarget } from 'react-dnd-old';


import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions, Control, Field } from 'react-redux-form';
import { useSetAtom } from 'jotai';
import { Icon } from "../../UI";
import { withContext } from "../../componentWrappers";
import { FormGroup } from "../../Forms";
import ColorPicker from "../../Forms/components/ColorPicker";
import { I18NLink, t, Translate } from "../../I18N";
import { notificationActions } from "../../Notifications";
import { notify } from "../../Notifications/actions/notificationsActions";
import { templatesAtom } from "../../V2/atoms";
import api from "../TemplatesAPI";
import {
  addProperty,
  inserted,
  saveTemplate,
  countByTemplate } from "../actions/templateActions";

import MetadataProperty from "./MetadataProperty";
import RemovePropertyConfirm from "./RemovePropertyConfirm";
import { AddThesaurusButton } from "../../Thesauri/components/AddThesaurusButton";
import { AddRelationshipTypeButton } from "../../RelationTypes/components/AddRelationshipTypeButton";
import { COLORS } from "../../utils/colors";



import { Form } from "../../Forms/Form";
import { TemplateAsPageControl } from "./TemplateAsPageControl";
import { validate } from "./ValidateTemplate";




















const getTemplateDefaultColor = (allTemplates, template) =>
template.data.color ? template.data.color : COLORS[allTemplates.size % COLORS.length];

class MetadataTemplate extends Component {


































  constructor(props) {
    super(props);_defineProperty(this, "confirmation", { templateConflict: { title: 'Template conflict', key: 'Mapping conflict error', text: `A reindex of your collection is necessary. The reason may vary
       -- from certain changes made to a template's property to new fields
       that need to be populated across entities.
       This process will not negatively affect the data in your collection.
       It can last a few minutes and some parts of your collection might take
       some time to reappear in the Library, but this is temporary. Do you want to continue?` }, largeNumberOfEntities: { title: 'Lengthy reindex process', key: 'Template with a long number of entities', text: `The template has changed and the associated entities will be re-indexed,
      this process may take several minutes, do you want to continue?` } });_defineProperty(this, "onSubmit", async (_template) => {var _template$properties;const template = _objectSpread({}, _template);
      if (this.props.environment === 'relationType') {
        template.commonProperties = undefined;
      }
      template.properties = (_template$properties = template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.map((_prop) => {
        const prop = _objectSpread({}, _prop);
        prop.label = _prop.label.trim();
        return prop;
      });
      if (template._id) {
        const entitiesCountOfTemplate = await countByTemplate(template);
        const lengthyReindexFloorCount = 30000;
        if (entitiesCountOfTemplate >= lengthyReindexFloorCount) {
          return this.confirmAndSaveTemplate(template, 'largeNumberOfEntities');
        }
      }
      try {
        await this.props.saveTemplate(template);
        const templates = await api.get('templates');
        this.props.updateTemplatesAtom(templates);
      } catch (e) {
        if (e.status === 409) return this.confirmAndSaveTemplate(template, 'templateConflict');
      }
    });this.onSubmit = this.onSubmit.bind(this);this.onSubmitFailed = this.onSubmitFailed.bind(this);}

  onSubmitFailed() {
    this.props.notify(t('System', 'The template contains errors', null, false), 'danger');
  }

  confirmAndSaveTemplate(
  template,
  confirmationKey)
  {
    return this.props.mainContext.confirm({
      accept: () => {
        try {
          this.props.saveTemplate(_objectSpread(_objectSpread({}, template), {}, { reindex: confirmationKey === 'templateConflict' }));
        } catch (e) {
          if (e.status === 409) return this.confirmAndSaveTemplate(template, 'templateConflict');
        }
      },

      cancel: () => {},
      title: this.confirmation[confirmationKey].title,
      messageKey: this.confirmation[confirmationKey].key,
      message: this.confirmation[confirmationKey].text,
      type: 'success',
      acceptLabel: 'Confirm',
      zIndex: 99
    });
  }

  render() {
    const { connectDropTarget, defaultColor, environment, syncedTemplate } = this.props;
    const commonProperties = this.props.commonProperties || [];
    return (/*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(RemovePropertyConfirm, {}), /*#__PURE__*/
      _jsx(Form, {
        model: "template.data",
        onSubmit: this.onSubmit,
        onSubmitFailed: this.onSubmitFailed,
        className: "metadataTemplate",
        validators: validate(
          this.props.properties,
          commonProperties,
          this.props.templates.toJS(),
          this.props._id
        ) }, void 0,

      environment === 'template' && syncedTemplate && /*#__PURE__*/
      _jsx("div", { className: "metadataTemplate-sync" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "exclamation-triangle" }), " \xA0", /*#__PURE__*/
      _jsx(Translate, { translationKey: "syncedTemplateEditorMessage" }, void 0, "This template is synced from another instance. Only entity view page can be enabled."

      )
      ), /*#__PURE__*/


      _jsx("div", { className: "metadataTemplate-heading" }, void 0, /*#__PURE__*/
      _jsx(FormGroup, { model: ".name" }, void 0, /*#__PURE__*/
      _jsx(Field, { model: ".name" }, void 0, /*#__PURE__*/
      _jsx("input", {
        placeholder: t('System', 'Template name', null, false),
        className: "form-control",
        disabled: syncedTemplate }
      )
      )
      ),
      defaultColor && !(environment === 'relationType') && /*#__PURE__*/
      _jsx(Control, {
        model: ".color",
        component: ColorPicker,
        defaultValue: defaultColor,
        mapProps: {
          defaultValue: (props) => props.defaultValue
        },
        disabled: syncedTemplate }
      )

      ),

      environment === 'template' && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", { className: "metadataTemplate-pageview" }, void 0, /*#__PURE__*/
      _jsx(FormGroup, { model: ".entityViewPage" }, void 0, /*#__PURE__*/
      _jsx(TemplateAsPageControl, { selectedPage: this.props.entityViewPage || '' })
      )
      ),
      connectDropTarget(/*#__PURE__*/
        _jsx("ul", { className: "metadataTemplate-list list-group" }, void 0,
        commonProperties.map((property, index) => /*#__PURE__*/
        React.createElement(MetadataProperty, _extends({},
        property, {
          key: property.localID,
          localID: property.localID,
          index: index - commonProperties.length,
          syncedTemplate: syncedTemplate })
        )
        ),
        this.props.properties.map((property, index) => /*#__PURE__*/
        _jsx(MetadataProperty, {
          _id: property._id,
          type: property.type,
          inserting: property.inserting,

          localID: property.localID,
          index: index,
          syncedTemplate: syncedTemplate
          // relationships v2
          , query: property.query,
          denormalizedProperty: property.denormalizedProperty }, property.localID
        )
        ),
        !syncedTemplate && /*#__PURE__*/
        _jsx("div", { className: "no-properties" }, void 0, /*#__PURE__*/
        _jsx("span", { className: "no-properties-wrap" }, void 0, /*#__PURE__*/
        _jsx(Icon, { icon: "clone" }), /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Drag properties here")
        )
        )

        )
      )
      ), /*#__PURE__*/


      _jsx("div", { className: "settings-footer remove-extra-nesting" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "btn-cluster" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, { to: this.props.backUrl, className: "btn btn-default btn-plain" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-left" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Back")
      )
      )
      ),
      environment === 'template' && /*#__PURE__*/
      _jsx("div", { className: "btn-cluster lg-margin-left-12 sm-order-1 sm-footer-extra-row" }, void 0, /*#__PURE__*/
      _jsx(AddThesaurusButton, {}), /*#__PURE__*/
      _jsx(AddRelationshipTypeButton, {})
      ), /*#__PURE__*/

      _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, { to: this.props.backUrl, className: "btn btn-default btn-extra-padding" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Cancel")
      )
      ), /*#__PURE__*/
      _jsx("button", {
        type: "submit",
        className: "btn btn-success save-template btn-extra-padding",
        disabled: !!this.props.savingTemplate }, void 0, /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Save")
      )
      )
      )
      )
      )
      ));

  }
}

/* eslint-disable react/forbid-prop-types, react/require-default-props */_defineProperty(MetadataTemplate, "defaultProps", { notify, /* eslint-disable react/default-props-match-prop-types */saveTemplate, environment: 'template', /* eslint-enable react/default-props-match-prop-types */savingTemplate: false, defaultColor: null, properties: [], mainContext: { confirm: (_props) => {} }, updateTemplatesAtom: (_templates) => {} });

















/* eslint-enable react/forbid-prop-types, react/require-default-props */

const target = {
  canDrop() {
    return true;
  },

  drop(props, monitor) {
    const item = monitor.getItem();

    const propertyAlreadyAdded = props.properties[item.index];

    if (propertyAlreadyAdded) {
      props.inserted(item.index);
      return {};
    }

    props.addProperty({ label: item.label, type: item.type }, props.properties.length);
    return { name: 'container' };
  }
};

const withTemplatesAtom =
(Comp) =>
(props) => {
  const updateTemplatesAtom = useSetAtom(templatesAtom);
  return /*#__PURE__*/React.createElement(Comp, _extends({}, props, { updateTemplatesAtom: updateTemplatesAtom }));
};

const dropTarget = DropTarget('METADATA_OPTION', target, (connector) => ({
  connectDropTarget: connector.dropTarget()
}))(withTemplatesAtom(MetadataTemplate));

const mapStateToProps = (
{
  template,
  templates,
  relationTypes













},

props) =>
{
  const environment = props.relationType ? 'relationType' : 'template';
  const _templates = environment === 'relationType' ? relationTypes : templates;
  return {
    _id: template.data._id,
    commonProperties: template.data.commonProperties,
    properties: template.data.properties,
    entityViewPage: template.data.entityViewPage,
    syncedTemplate: template.data.synced,
    templates: _templates,
    savingTemplate: template.uiState.get('savingTemplate'),
    defaultColor: getTemplateDefaultColor(templates, template),
    environment
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { inserted, addProperty, setErrors: formActions.setErrors, notify: notificationActions.notify },
    dispatch
  );
}

export { dropTarget, MetadataTemplate, mapStateToProps };

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(
  withContext(dropTarget)
);